export const LOAD_QUESTIONS = 'LOAD_QUESTIONS'
export const UNLOAD_QUESTIONS = 'UNLOAD_QUESTIONS'

export default {
	[LOAD_QUESTIONS] (state, payload) {
		state.list = payload.data
	},
	[UNLOAD_QUESTIONS] (state, payload) {
		state.list = payload.data
	}
}
